import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React, { forwardRef, useState, useImperativeHandle, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@skatteetaten/ds-buttons';
import { dsI18n, useMediaQuery, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { VerticalDotsSVGpath } from '@skatteetaten/ds-icons';
import { B as BreadcrumbsListContext } from '../BreadcrumbsListContext.esm.js';
import './styles.css';


const getBreadcrumbsListShouldCollapseDefault = ()=>true;
const getBreadcrumbsListShowLastItemAsCurrentPageDefault = ()=>true;

var styles = {
    "breadcrumbsList": "BreadcrumbsList-module_breadcrumbsList__Kmse1",
    "expandButtonWrapper": "BreadcrumbsList-module_expandButtonWrapper__9Foby"
};

const BreadcrumbsList = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, shouldCollapse = getBreadcrumbsListShouldCollapseDefault(), showLastItemAsCurrentPage = getBreadcrumbsListShowLastItemAsCurrentPageDefault(), children }, ref)=>{
    const { t } = useTranslation('ds_navigation', {
        i18n: dsI18n
    });
    const [isExpanded, setIsExpanded] = useState(false);
    const isMobile = !useMediaQuery('(min-width: 640px)');
    const isCollapsed = shouldCollapse && !isExpanded && isMobile;
    useImperativeHandle(ref, ()=>listRef.current);
    const listRef = useRef(null);
    const handleExpand = ()=>{
        setIsExpanded(true);
        setTimeout(()=>{
            if (listRef.current) {
                const childLinkElements = [
                    ...listRef.current.querySelectorAll('a')
                ];
                childLinkElements[0].focus();
            }
        }, 0);
    };
    const childrenAsArray = React.Children.toArray(children);
    const concatenatedClassNames = `${styles.breadcrumbsList} ${className}`.trim();
    return /*#__PURE__*/ jsx(BreadcrumbsListContext.Provider, {
        value: {
            showLastItemAsCurrentPage,
            itemCount: childrenAsArray.length
        },
        children: /*#__PURE__*/ jsx("ol", {
            ref: listRef,
            id: id,
            lang: lang,
            "data-testid": dataTestId,
            className: concatenatedClassNames,
            children: !isCollapsed || childrenAsArray.length <= 3 ? childrenAsArray : /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsxs("li", {
                        className: styles.expandButtonWrapper,
                        children: [
                            /*#__PURE__*/ jsx(IconButton, {
                                size: 'small',
                                title: t('breadcrumbs.ExpandAltText'),
                                svgPath: VerticalDotsSVGpath,
                                onClick: handleExpand
                            }),
                            /*#__PURE__*/ jsx("span", {
                                "aria-hidden": 'true',
                                children: '/'
                            })
                        ]
                    }),
                    childrenAsArray.slice(-2)
                ]
            })
        })
    });
});
BreadcrumbsList.displayName = 'BreadcrumbsList';

export { BreadcrumbsList, getBreadcrumbsListShouldCollapseDefault, getBreadcrumbsListShowLastItemAsCurrentPageDefault };
